<template>
  <div v-frag>
    <SmartCollection
      v-if="collection"
      :collection="collection"
      :relative-to-container="relativeToContainer"
      min-height="auto"
    />
  </div>
</template>
<script>
import catchify from 'catchify';
import frag from 'vue-frag';
import { SMART_COLLECTIONS_URL } from '@/constants/api';
import SmartCollection from './SmartCollection';
import { formatConditions } from '~/util/collections';

export default {
  directives: { frag },
  components: {
    SmartCollection,
  },
  props: {
    zone: {
      type: String,
      required: true,
    },
    templateSlug: {
      type: String,
      required: false,
      default: '',
    },
    /* jw: controls whether the carousel's width will be based on its container or the viewport */
    relativeToContainer: {
      type: Boolean,
      default: false,
    },
    conditions: {
      type: [Object, Array],
      default: () => ({}),
      required: false,
    },
    preloadedData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    const collection = this.preloadedData !== null && Object.keys(this.preloadedData).length > 0
      ? this.preloadedData : null;

    if (collection) {
      switch (collection.component_type) {
        case 'grid': collection.component_product_num = 3; break;
        default: break;
      }
    }

    return {
      collection,
    };
  },
  async fetch() {
    if (this.preloadedData === null) {
      const conditions = formatConditions(this.conditions);
      const [error, response] = await catchify(
        this.$cachios.get(`${SMART_COLLECTIONS_URL}/zone/${this.zone}/?format=json&template_slug=${this.templateSlug}&conditions=${conditions}`),
      );
      if (error) {
        // log to gray log on server, no log on client - the entire section wont show
        if (process.server) {
          console.log(`Error retrieving embedded smart collection ${this.zone} (${this.templateSlug || 'N/A'}):`, error); // eslint-disable-line no-console
        }
      } else {
        const { data: collection = {} } = response || {};
        if (collection && collection.id) {
          this.collection = collection;
          switch (this.collection.component_type) {
            case 'grid': this.collection.component_product_num = 3; break;
            default: break;
          }
        }
      }
    }
  },
};
</script>
